module.exports = __webpack_public_path__ + "img/hired.fd569a13.svg";